module.exports = __webpack_public_path__ + "static/media/Ashmayu_Balloon_B.a9b08870.png";